export class RegexUtil {
  static readonly EMAIL_REGEX: string = "^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$";
  static readonly SCRIPT_REGEX: string = "<script|javascript|\\/script>";
}
